export default __webpack_public_path__ + "static/journaldesfemmes-e1645187334139-2d3a5e1b099bd080debd63d9bc65b246.webp";